//----------------------------------------------------------------------------------------------------------------
// Copyright DeerSoft - 2019
//----------------------------------------------------------------------------------------------------------------
import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./newpricing.css";
const NewNavBar = React.lazy(()=>import("../ProductionAssistLandingPage/NewNavBar"));
import LocalizedStrings from "../../localization/ProductionAssistLandingPage";
import NewFooter from "../WebComponents/NewFooter";
import IMG_VISA from "../../content/img/visa.png";
import IMG_SEPA from "../../content/img/sepa.png";
import IMG_MASTERCARD from "../../content/img/mastercard.png";
const CHECK = "check";
const UNCHECK = "uncheck";

class NewPricingPage extends Component {
  constructor() {
    super();
    this.state = {
      isMonthly: true
    }
  }
  render() {
   const isMonthly = this.state.isMonthly;
    return (
    <>
      <div className="newpricing-page">
        <header>
            <NewNavBar/>
            <div className="main-heading">
                <h2 className="desktop">{LocalizedStrings.Pricing_Explore}</h2>
                <h1>{LocalizedStrings.PricingHeader}</h1>
                <h3>{LocalizedStrings.PricingText}</h3>
            </div>
        </header>

        <div className="switchingPrice">
          <span className={isMonthly ? "selected" : ""} onClick={() => this.setState(() => ({ isMonthly: true }))}>{LocalizedStrings.Monthly}</span>
          <span className={!isMonthly  ? "selected" : ""} onClick={() => this.setState(() => ({ isMonthly: false }))}>{LocalizedStrings.Yearly}</span>
        </div>
        <section className="packages">
            <div className="package community">
                <h4>{LocalizedStrings.Pricing_Plan_Free}</h4>
                <div className="price">
                <h3 style={{ fontWeight: 900 }}>0 <span style={{ fontWeight: 300 }} className="month">{isMonthly ? LocalizedStrings.Month : LocalizedStrings.Year}</span></h3>
                </div>
                <div className="benefit">
                    <p>{LocalizedStrings.BulletPoint_Plan}</p>
                    <p>{LocalizedStrings.Pricing_StructuralCalculations_CalculateFree}</p>

                </div>
                <Link to="/register"><button className="register-btn">{LocalizedStrings.RegisterNow}</button></Link>

            </div>

            <div className="package basic">
                <h4>{LocalizedStrings.Pricing_Plan_Basic}</h4>
                <div className="price">
                    <h3>{isMonthly ? 20 : 200}<span className="month">{isMonthly ? LocalizedStrings.Month : LocalizedStrings.Year}</span></h3>
                </div>
                <div className="benefit">
                    <span>{LocalizedStrings.EverythingFromCommunity}</span>
                    <p>{LocalizedStrings.BulletPoint_Export}</p>
                    <p>{LocalizedStrings.BulletPoint_Labels}</p>
                    <p>{LocalizedStrings.Pricing_StructuralCalculations_CalculateNewBasic}</p>
                </div>
                <Link to="/register"><button className="register-btn">{LocalizedStrings.RegisterNow}</button></Link>
            </div>

            <div className="package team">
                <h4>{LocalizedStrings.Pricing_Plan_ProTeams}</h4>
                <div className="price">
                    <h3>{isMonthly ? 120 : 1200}<span className="month">{isMonthly ? LocalizedStrings.Month : LocalizedStrings.Year}</span></h3>
                    <p>{LocalizedStrings.InclFiveUsers}</p>
                </div>
                <div className="benefit">
                    <span>{LocalizedStrings.NewEverythingFromBasic}</span>
                    <p>{LocalizedStrings.BulletPoint_Online}</p>
                    <p>{LocalizedStrings.BulletPoint_Collorboration}</p>
                    <p>{LocalizedStrings.Pricing_StructuralCalculations_CalculateProTeam}</p>
                    <p>{LocalizedStrings.BulletPoint_AdditionalUser}</p>
                </div>
                <Link to="/register"><button className="register-btn">{LocalizedStrings.RegisterNow}</button></Link>
            </div>

            <div className="package arena">
                <h4>{LocalizedStrings.Pricing_Plan_Arena}</h4>
                <div className="price">
                    <h3>{isMonthly ? 600 : 6000}<span className="month">{isMonthly ? LocalizedStrings.Month : LocalizedStrings.Year}</span></h3>
                    <p>{LocalizedStrings.InclFiveUsers}</p>
                </div>
                <div className="benefit">
                    <span>{LocalizedStrings.EverythingFromTeams}</span>
                    <p>{LocalizedStrings.Pricing_StructuralCalculations_CalculateChainShortenEffect}</p>
                    <p>{LocalizedStrings.BulletPoint_ProveCompleteVenueRoofs}</p>
                    <p>{LocalizedStrings.BulletPoint_LoadMeasurementCells}</p>
                    <p>{LocalizedStrings.BulletPoint_ScriptBasedProves}</p>
                    <p>{LocalizedStrings.BulletPoint_PrioritySupport}</p>
                    <p>{LocalizedStrings.BulletPoint_AdditionalUser}</p>
                </div>
                <Link to="/register"><button className="register-btn">{LocalizedStrings.RegisterNow}</button></Link>
            </div>
            <div className="dark-bg"></div>
        </section>

        <section className="payment">
            <h2>{LocalizedStrings.PaymentOption}</h2>
            <div className="method">
                <img className="visa" src={IMG_VISA} alt="visa" />
                <img className="master" src={IMG_MASTERCARD} alt="mastercard" />
                <img className="sepa" src={IMG_SEPA} alt="sepa" />
            </div>
        </section>

        <section className="compare">
            <h1>{LocalizedStrings.CompareAndFind}</h1>
            <h1>{LocalizedStrings.WhatSuitYou}</h1>
            <h3>{LocalizedStrings.YouAreNotSure}</h3>
            <div className="btn-group">
                <Link to="https://meetings.engagebay.com/MoritzStaffel"><button className="btn orange-btn">{LocalizedStrings.RequestDemo}</button></Link>
                <Link to="https://meetings.engagebay.com/MoritzStaffel"><button className="btn grey-btn">{LocalizedStrings.TalkToUs}</button></Link>
             </div>
        </section>

        <section className="info desktop">
            <div className="list community">
                <h4>{LocalizedStrings.Pricing_Plan_Free}</h4>
                <div className="details">
                    {this.display_Pricing_General(CHECK, CHECK, CHECK, CHECK, UNCHECK, CHECK, CHECK, CHECK, CHECK, CHECK, UNCHECK, CHECK, CHECK)}
                    {this.display_Pricing_Paperwork(CHECK, UNCHECK, UNCHECK, UNCHECK)}
                    {this.display_Pricing_OnlineWorkflow(CHECK, UNCHECK, UNCHECK, UNCHECK, UNCHECK)}
                    {this.display_Pricing_StructuralCalculations(CHECK, UNCHECK, UNCHECK, UNCHECK, UNCHECK, UNCHECK, CHECK, 6, UNCHECK, UNCHECK, UNCHECK, UNCHECK, UNCHECK)}
                    {this.display_Pricing_ElectricalCalculations(CHECK, CHECK, 20)}
                    {this.display_Pricing_Truckplanning(CHECK, CHECK, CHECK, UNCHECK, 10, 2, 2)}
                    {this.display_Pricing_Plugins(CHECK, CHECK)}
                </div>
                <div className="signup">
                    <Link to="/register"><button className="register-btn">{LocalizedStrings.SignMeUp}</button></Link>   
                </div>
            </div>

            <div className="list basic">
                <h4>{LocalizedStrings.Pricing_Plan_Basic}</h4>
                <div className="details">
                    {this.display_Pricing_General(CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_Paperwork(CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_OnlineWorkflow(CHECK, CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_StructuralCalculations(CHECK, UNCHECK, UNCHECK, CHECK, CHECK, CHECK, CHECK, 30, UNCHECK, UNCHECK, UNCHECK, CHECK, UNCHECK)}
                    {this.display_Pricing_ElectricalCalculations(CHECK, CHECK, 100)}
                    {this.display_Pricing_Truckplanning(CHECK, CHECK, CHECK, UNCHECK, 50, 10, 10)}
                    {this.display_Pricing_Plugins(CHECK, CHECK)}
                </div>
                <div className="signup">
                    <Link to="/register"><button className="register-btn">{LocalizedStrings.SignMeUp}</button></Link>   
                </div>
            </div>

            <div className="list team">
                <h4>{LocalizedStrings.Pricing_Plan_ProTeams}</h4>
                <div className="details">
                    {this.display_Pricing_General(CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_Paperwork(CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_OnlineWorkflow(CHECK, CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_StructuralCalculations(CHECK, CHECK, UNCHECK, CHECK, CHECK, CHECK, CHECK, LocalizedStrings.NoLimit, UNCHECK, UNCHECK, UNCHECK, CHECK, UNCHECK)}
                    {this.display_Pricing_ElectricalCalculations(CHECK, CHECK, LocalizedStrings.NoLimit)}
                    {this.display_Pricing_Truckplanning(CHECK, CHECK, CHECK, CHECK, LocalizedStrings.NoLimit, LocalizedStrings.NoLimit, LocalizedStrings.NoLimit)}
                    {this.display_Pricing_Plugins(CHECK, CHECK)}
                </div>
                <div className="signup">
                    <Link to="/register"><button className="register-btn">{LocalizedStrings.SignMeUp}</button></Link>   
                </div>
            </div>

            <div className="list arena">
                <h4>{LocalizedStrings.Pricing_Plan_Arena}</h4>
                <div className="details">
                    {this.display_Pricing_General(CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_Paperwork(CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_OnlineWorkflow(CHECK, CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_StructuralCalculations(CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, CHECK, LocalizedStrings.NoLimit, CHECK, CHECK, CHECK, CHECK, CHECK)}
                    {this.display_Pricing_ElectricalCalculations(CHECK, CHECK, LocalizedStrings.NoLimit)}
                    {this.display_Pricing_Truckplanning(CHECK, CHECK, CHECK, CHECK, LocalizedStrings.NoLimit, LocalizedStrings.NoLimit, LocalizedStrings.NoLimit)}
                    {this.display_Pricing_Plugins(CHECK, CHECK)}
                </div>
                <div className="signup">
                    <Link to="/register"><button className="register-btn">{LocalizedStrings.SignMeUp}</button></Link>   
                </div>
            </div>
        </section>

        <NewFooter/>
      </div>
    </>
    );
  }

  display_Pricing_General(s1,s2,s3,s4,s5,s6,s7,s8,s9,s10,s11,s12,s13)
  {
    return (
      <div>
        <h5>{LocalizedStrings.GeneralFeature}</h5>
        <p className={s1}>{LocalizedStrings.Pricing_General_OnlineContent}</p>
        <p className={s2}>{LocalizedStrings.Pricing_General_PrivateContent}</p>
        <p className={s3}>{LocalizedStrings.Pricing_General_Draw3D}</p>
        <p className={s4}>{LocalizedStrings.Pricing_General_Draw2D}</p>
        <p className={s5}>{LocalizedStrings.Pricing_General_ExportView}</p>
        <p className={s6}>{LocalizedStrings.Pricing_General_ExportSheetLayer}</p>
        <p className={s7}>{LocalizedStrings.Pricing_General_MeshImport}</p>
        <p className={s8}>{LocalizedStrings.Pricing_General_TextureImport}</p>
        <p className={s9}>{LocalizedStrings.Pricing_General_DXFDWG}</p>
        <p className={s10}>{LocalizedStrings.Pricing_General_Preset}</p>
        <p className={s11}>{LocalizedStrings.Pricing_General_QRCodes}</p>
        <p className={s12}>{LocalizedStrings.Pricing_General_Dimension}</p>
        <p className={s13}>{LocalizedStrings.Pricing_General_Selection}</p>
      </div>
    )      
  }

  display_Pricing_Paperwork(s1, s2, s3, s4) {
    return (
      <div>
        <h5>{LocalizedStrings.Pricing_Paperwork}</h5>
        <p className={s1}>{LocalizedStrings.Pricing_Paperwork_CreateReport}</p>
        <p className={s2}>{LocalizedStrings.Pricing_Paperwork_ExportPDF}</p>
        <p className={s3}>{LocalizedStrings.Pricing_Paperwork_ReportOnline}</p>
        <p className={s4}>{LocalizedStrings.Pricing_Paperwork_QRCode}</p>
      </div>
    );
  }

  display_Pricing_OnlineWorkflow(s1, s2, s3, s4, s5) {
    return (
      <div>
        <h5>{LocalizedStrings.Pricing_OnlineWorkflow}</h5>
        <p className={s1}>{LocalizedStrings.Pricing_OnlineWorkflow_HostOnline}</p>
        <p className={s2}>{LocalizedStrings.Pricing_OnlineWorkflow_Collorborate}</p>
        <p className={s3}>{LocalizedStrings.Pricing_OnlineWorkflow_ShareLinks}</p>
        <p className={s4}>{LocalizedStrings.Pricing_OnlineWorkflow_ProjectMembers}</p>
        <p className={s5}>{LocalizedStrings.Pricing_OnlineWorkflow_Tasks}</p>
      </div>
    );
  }

  display_Pricing_StructuralCalculations(s1, s2, s3, s4, s5, s6, s7, count, s8, s9, s10, s11, s12) {
    return (
      <div>
        <h5>{LocalizedStrings.Pricing_StructuralCalculations}</h5>
        <p className={s7}>{LocalizedStrings.Pricing_StructuralCalculations_ElectricalCalculation}</p>
        <p className={s11}>{LocalizedStrings.Pricing_StructuralCalculations_AccessToEngineeringService}</p>
        <p className={s1}>{LocalizedStrings.Pricing_StructuralCalculations_Count} : <b>{count}</b></p>
        <p className={s2}>{LocalizedStrings.Pricing_StructuralCalculations_DSTV}</p>
        <p className={s3}>{LocalizedStrings.Pricing_StructuralCalculations_ImportDSTV}</p>
        <p className={s4}>{LocalizedStrings.Pricing_StructuralCalculations_Report}</p>
        <p className={s5}>{LocalizedStrings.Pricing_StructuralCalculations_PartCalculations}</p>
        <p className={s6}>{LocalizedStrings.Pricing_StructuralCalculations_LoadCombinations}</p>
        <p className={s12}>{LocalizedStrings.Pricing_StructuralCalculations_CalculateChainShortenEffect}</p>
        <p className={s8}>{LocalizedStrings.Pricing_StructuralCalculations_Venues}</p>
        <p className={s9}>{LocalizedStrings.Pricing_StructuralCalculations_LoadCells}</p>
        <p className={s10}>{LocalizedStrings.Pricing_StructuralCalculations_ScriptBased}</p>
      </div>
    );
  }

  display_Pricing_ElectricalCalculations(s1, s2, count) {
    return (
      <div>
        <h5>{LocalizedStrings.Pricing_ElectricalCalculations}</h5>
        <p className={s1}>{LocalizedStrings.Pricing_ElectricalCalculations_ElectricalCalculation}</p>
        <p className={s2}>{LocalizedStrings.Pricing_ElectricalCalculations_Count} : <b>{count}</b></p>
      </div>
    );
  }

  display_Pricing_Truckplanning(s1, s2, s3, s4, cases, racks, trucks) {
    return (
      <div>
        <h5>{LocalizedStrings.Pricing_Truckplanning}</h5>
        <p className={s1}>{LocalizedStrings.Pricing_Truckplanning_Cases} : <b>{cases}</b></p>
        <p className={s2}>{LocalizedStrings.Pricing_Truckplanning_Racks} : <b>{racks}</b></p>
        <p className={s3}>{LocalizedStrings.Pricing_Truckplanning_Truck} : <b>{trucks}</b></p>
        <p className={s4}>{LocalizedStrings.Pricing_Truckplanning_AutoPlace}</p>
      </div>
    );
  }
  
  display_Pricing_Plugins(s1, s2) {
    return (
      <div>
        <h5>{LocalizedStrings.Pricing_Plugins}</h5>
        <p className={s1}>{LocalizedStrings.Pricing_Plugins_Vectorworks}</p>
        <p className={s2}>{LocalizedStrings.Pricing_Plugins_grandMA3}</p>
      </div>
    );
  }
}

export default NewPricingPage;